import { render } from "./WangosProjectThree.vue?vue&type=template&id=131d59d3"
import script from "./WangosProjectThree.vue?vue&type=script&lang=js"
export * from "./WangosProjectThree.vue?vue&type=script&lang=js"

import "./WangosProjectThree.vue?vue&type=style&index=0&id=131d59d3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__